
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"RSSicon","viewBox":"0 0 8 8","width":"256","height":"256"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('RSS feed icon')]),_c('rect',{staticClass:"button",attrs:{"width":"8","height":"8","rx":"1.5"}}),_c('circle',{staticClass:"symbol",attrs:{"cx":"2","cy":"6","r":"1"}}),_c('path',{staticClass:"symbol",attrs:{"d":"m 1,4 a 3,3 0 0 1 3,3 h 1 a 4,4 0 0 0 -4,-4 z"}}),_c('path',{staticClass:"symbol",attrs:{"d":"m 1,2 a 5,5 0 0 1 5,5 h 1 a 6,6 0 0 0 -6,-6 z"}})])
          )
        }
      }
    